module.exports = __webpack_public_path__ + "img/13.b0df7cc4.jpg";